import React from 'react';
import { useChildrenValidation } from '../../hooks/useChildrenValidation';
import { AccordionBody } from './AccordionBody';
import { AccordionHeader } from './AccordionHeader';
import { AccordionSubContext } from './context';
export function AccordionItem(_ref) {
  var children = _ref.children,
      id = _ref.id;
  useChildrenValidation(children, 'AccodionItem', [AccordionHeader, AccordionBody]);
  return /*#__PURE__*/React.createElement(AccordionSubContext.Provider, {
    value: {
      id: id
    }
  }, children);
}
AccordionItem.displayName = 'AccordionItem';